module.exports = __webpack_public_path__ + "img/minshengbanner.9c0489c2.png";